<script>
	import Data from '../../States/Data';
	import Helper from '../../Models/Helper';
	import Session from '../../States/Session';
	import Slider from '../../States/Slider';

	export let index = 0;

	let books_element = {};
	let chapters_element = {};
	let properties = {};
	let version = {};
	let books = [];
	let book = {};
	let number = 0;
	let active = false;

	async function init() {
		Helper.title('Boeken');
		const version = await Data.relative('version');
		const base = version.testaments[0].books.concat(version.testaments[1].books);
		books = base.sort((a, b) => { return (a.name < b.name) ? -1 : 1 });

		let reading = [];
		let initial = 0;
		if (Helper.is($Slider.slide_5.properties)) {
			reading = $Slider.slide_5.properties.chapter.split('_');
			number = reading[1];
			for (let thing in books)
				if (books[thing].code == reading[0]) {
					initial = thing;
					break;
				}
		}

		await chapters(books[initial]);
	}

	async function chapters(item, pressed) {
		book = await Data.relative(`books/${item.code}`);
		if (pressed) number = 1;

		const scroll = container => {
			let base = jQuery(container);
			let element = base.find('.item.active');
			let top = element.offset().top - base.offset().top + base.scrollTop();
			top = ((top - 34) > 0) ? (top - 34) : 0;
			base.animate({scrollTop: top}, 1000 * .5);
		};

		const delay = () => {
			scroll(books_element);
			scroll(chapters_element);
		};

		setTimeout(delay, 250);
	}

	function updateSlider(slides) {
		active = Slider.check(index, 'index', properties);
		if (active) {
			properties = Slider.properties(index);
			active = properties.active;
		}
	}

	init();
	Slider.subscribe(updateSlider);
</script>

<style>
	div.content {
		overflow: hidden;
		touch-action: none;
		position: relative;
	}

	h3.solid.list {
		color: var(--secondary-color);
	}

	div.duo {
		display: flex;
		position: absolute;
		top: 1em;
		right: 10vw;
		bottom: 1em;
		left: 10vw;
	}

	div.duo div.books div.scroll,
	div.duo div.chapters div.scroll {
		touch-action: pan-y;
		overflow-x: hidden;
		overflow-y: auto;
		height: calc(100% - 3em);
	}

	div.duo div.books {
		width: 75%;
		padding-right: 1.7em;
		border-right: 1px solid var(--tertiary-background-light);
	}

	div.duo div.chapters {
		width: 25%;
		padding-right: 1em;
		padding-left: 1.7em;
	}

	div.duo div.list {
		margin-bottom: 0;
	}

	.item.active {
		color: var(--box-background);
		background: var(--tertiary-color) !important;
	}

	@media (max-device-width: 768px) {
		div.duo {
			top: 1.25em;
			right: 3vw;
			bottom: 1em;
			left: 6vw;
		}

		div.duo div.books {
			padding-right: 1em;
		}

		div.duo div.chapters {
			padding-left: 1em;
			text-align: center;
		}

		div.duo div.chapters i {
			display: none;
		}

		div.duo div.books div.scroll,
		div.duo div.chapters div.scroll {
			height: calc(100% - 1em);
		}

		h3 {
			display: none;
		}
	}
</style>

<div class="box feature" class:active>
	<div class="menu">
		<div class="begin">
			<div class="title">Boeken</div>
		</div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content">
		{#if Helper.is(books, book)}
			<div class="duo">
				<div class="books">
					<h3 class="solid list">Boeken</h3>
					<div bind:this="{books_element}" class="scroll">
						<div class="solid compact list">
							{#each books as item}
								<div class="item" class:active="{item.code == book.code}" on:click="{event => chapters(item, true)}">
									<i class="fad fa-chevron-right"></i>
									<div>{item.name}</div>
								</div>
							{/each}
						</div>
					</div>
				</div>
				<div class="chapters">
					<h3 class="solid list">{book.name}</h3>
					<div bind:this="{chapters_element}" class="scroll">
						<div class="solid compact list">
							{#each book.chapters as chapter}
								<a class="item" href="/{book.uri}/{chapter.number}" class:active="{chapter.number == number}">
									<i class="fad fa-chevron-right"></i>
									<div>{chapter.number}</div>
								</a>
							{/each}
						</div>
					</div>
				</div>
			</div>
		{/if}
	</div>
</div>